import { render, staticRenderFns } from "./SourceAutocomplete.vue?vue&type=template&id=2ed2c68c&"
import script from "./SourceAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./SourceAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports